import { Box, useDisclosure } from "@chakra-ui/react"
import { useObserveSizeContext } from "@pathwright/ui/src/components/observers/ObserveSizeContext"
import { AugmentationToolbarProps } from "@pathwright/ux/src/components/augmentation/AugmentationToolbar"
import AugmentationToolbarPopover from "@pathwright/ux/src/components/augmentation/AugmentationToolbarPopover"
import UserAvatar from "@pathwright/ux/src/components/avatar/UserAvatar"
import { Indicator } from "@pathwright/ux/src/components/button/IconButton"
import MenuButton from "@pathwright/ux/src/components/button/MenuButton"
import React from "react"
import { SignInLinkButton } from "../../auth/SignInLinkButton"
import { useNotificationsState } from "../../notifications/state/notification-state"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"

function HomeAugmentationPopoverWrapper({
  children,
  className = "HomeAugmentationPopover"
}: {
  children: React.ReactNode
  className?: string
}) {
  const { getRectValue } = useObserveSizeContext()
  const alertHeight = getRectValue("alert.height")

  return (
    <Box
      className={className}
      pos="fixed"
      top={`calc(1rem + ${alertHeight || 0}px)`}
      right="1rem"
      zIndex="overlay"
      minW="2rem"
    >
      {children}
    </Box>
  )
}

export const HomeAugmentationPopoverSignedOut = () => {
  const { me } = usePathwrightContext()

  if (me) return null

  return (
    <HomeAugmentationPopoverWrapper>
      <SignInLinkButton />
    </HomeAugmentationPopoverWrapper>
  )
}

export const HomeAugmentationPopoverSignedIn = React.forwardRef<
  HTMLDivElement,
  AugmentationToolbarProps
>(function HomeAugmentationPopoverSignedIn({ toolbar }, ref) {
  const { me } = usePathwrightContext()
  const { unreadCount } = useNotificationsState()
  const disclosure = useDisclosure()

  if (!me) return null

  return (
    <HomeAugmentationPopoverWrapper>
      <AugmentationToolbarPopover
        ref={ref}
        toolbar={toolbar}
        disclosure={disclosure}
      >
        <MenuButton
          as="div"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Box boxSize="2rem" borderRadius="full">
            <UserAvatar user={me} w="100%" h="100%" />
            {!!unreadCount && !disclosure.open && <Indicator />}
          </Box>
        </MenuButton>
      </AugmentationToolbarPopover>
    </HomeAugmentationPopoverWrapper>
  )
})

const HomeAugmentationPopover = React.forwardRef<
  HTMLDivElement,
  AugmentationToolbarProps
>(function HomeAugmentationPopover(props, ref) {
  const { me } = usePathwrightContext()

  if (me) {
    return <HomeAugmentationPopoverSignedIn ref={ref} {...props} />
  }

  return <HomeAugmentationPopoverSignedOut />
})

export default HomeAugmentationPopover
